import {
    Table
} from 'antd';
import dayjs from "dayjs";



const monthNames = [
  'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
  'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
];

const formatNumber = (number) => {
  if (typeof number === 'number') {
    return new Intl.NumberFormat('ru-RU').format(number);
  }
  return number;
};

const formatDate = (date) => {


  if (typeof date === 'number') {
    if (date >= 1 && date <= 12) {
      const currentYear = new Date().getFullYear();
      return `${monthNames[date - 1]} ${currentYear} г.`;
    }
    return date;
  }

  if (typeof date === 'string') {
    const parsedDate = new Date(date);
    if (!isNaN(parsedDate)) {
      return dayjs(date).format('DD MMMM YYYY')
    }
    return dayjs(date).format('DD-MMMM-YYYY')
  }

  return dayjs(date).format('DD-MMMM-YYYY')
};


const isValidDate = (dateString) => {
  const date = new Date(dateString);
  return !isNaN(date.getTime());
};

const generateColumns = (data) => {
  if (!data || data.length === 0) {
    return [];
  }

  const columns = Object.keys(data[0]).map((key) => ({
    title: key.charAt(0).toUpperCase() + key.slice(1),
    dataIndex: key,
    key: key,
    render: (text, row) => {
      if (
          // typeof text === 'number' && (text >= 0 && text <= 12) ||
          typeof text === 'string' && isValidDate(text)
      ) {
        return formatDate(text);
      }
      if (typeof text === 'number') {
        return formatNumber(text);
      }

      return text;
    },
  }));

  return columns;
};




function TableChat({ data }) {


  const columns = generateColumns(data);


  return (
      <Table
          dataSource={data}
          columns={columns}
          size={'small'}
          style={{
            width: '100%',
            padding: '10px',
            background: "#fff",
            borderRadius: '0px 24px 24px'
          }}
          pagination={data?.length > 1000 ? { pageSize: 50, showSizeChanger: false  } : false}

      />
  );
}

export default TableChat;
